import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateUserIntegrationState } from "./types";
import { IIntegration } from "@/shared/api/settings";

const initialState: UpdateUserIntegrationState = {
    isUpdateUserIntegrationModalOpen: false,
    isCreateUserIntegrationModalOpen: false,
    isDeleteUserIntegrationModalOpen: false,
    currentIntegration: {
        callback_url: "",
        id: ""
    },
    onDelete: null,
    onCreate: null,
    onUpdate: null
}

interface OpenCreateUserIntegrationModal {
    onSuccess?: () => void
}

interface OpenUpdateUserIntegrationModal {
    data: IIntegration
    onSuccess?: () => void
}

interface OpenDeleteUserIntegrationModal {
    data: IIntegration
    onSuccess?: () => void
}

export const updateUserIntegrationSlice = createSlice({
    name: 'updateUserIntegration',
    initialState,
    reducers: {
        openCreateUserIntegrationModal: (state, action: PayloadAction<OpenCreateUserIntegrationModal>) => {
            state.isCreateUserIntegrationModalOpen = true
            state.onCreate = action.payload.onSuccess
        },
        closeCreateUserIntegrationModal: (state) => {
            state.isCreateUserIntegrationModalOpen = false
        },
        openUpdateUserIntegrationModal: (state, action: PayloadAction<OpenUpdateUserIntegrationModal>) => {
            state.isUpdateUserIntegrationModalOpen = true
            state.onUpdate = action.payload.onSuccess
            state.currentIntegration = action.payload.data
        },
        closeUpdateUserIntegrationModal: (state) => {
            state.isUpdateUserIntegrationModalOpen = false
        },
        openDeleteUserIntegrationModal: (state, action: PayloadAction<OpenDeleteUserIntegrationModal>) => {
            state.isDeleteUserIntegrationModalOpen = true
            state.onDelete = action.payload.onSuccess
            state.currentIntegration = action.payload.data
        },
        closeDeleteUserIntegrationModal: (state) => {
            state.isDeleteUserIntegrationModalOpen = false
        },
    }
})

export default updateUserIntegrationSlice.reducer
export const {
    closeCreateUserIntegrationModal,
    closeDeleteUserIntegrationModal,
    closeUpdateUserIntegrationModal,
    openCreateUserIntegrationModal,
    openDeleteUserIntegrationModal,
    openUpdateUserIntegrationModal
} = updateUserIntegrationSlice.actions